"use client";

import { buildFaqPageSchema, type FaqItem } from "@/lib/faqSchema";

interface FaqPageSchemaProps {
  faqs: FaqItem[];
  datePublished?: string;
}

export default function FaqPageSchema({
  faqs,
  datePublished,
}: FaqPageSchemaProps) {
  const schema = buildFaqPageSchema(faqs, { datePublished });
  if (!schema) return null;

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}
